// Shared display helpers used inside ERP grid column renderers and the
// detail drawer. Keep them pure & cheap — they're called inside hot
// render paths for thousands of cells when a module paginates a large
// master.

// ── Indian numbering for currency.
// 1,50,000.00 (lakh-comma grouping), not 150,000.00.
// `decimals` defaults to 2 to match how ledger amounts are displayed
// elsewhere in the app (subscription invoices, plan price quotes).
export function formatINR(
  value,
  { decimals = 2, withSymbol = true } = {}
) {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  const fixed = n.toLocaleString('en-IN', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
  // Non-breaking space between symbol and digits so the pair never
  // wraps to two lines inside narrow numeric cells.
  return withSymbol ? `₹ ${fixed}` : fixed;
}

// Whole-rupee variant — for columns where decimals add noise (e.g.,
// Credit Limit summaries, totals on dashboards).
export function formatINRWhole(value, { withSymbol = true } = {}) {
  return formatINR(value, { decimals: 0, withSymbol });
}

// True if a value should render the muted em-dash instead of itself.
export function isEmptyCell(value) {
  if (value === null || value === undefined) return true;
  if (typeof value === 'string' && value.trim() === '') return true;
  return false;
}
